import * as React from 'react';

import { TotemLabel } from '../TotemLabel';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/ui/table';

import { getExtendedFormattedDatetime } from '../../helpers/dateTimes';

type StateRecord = {
    // Un libellé brut ou un composant de statut : la table ne fait que le rendre.
    state: React.ReactNode;
    createdAt: number;
    createdBy?: string | null;
    createdByName?: string | null;
};

function getCreatorName(createdBy?: string | null, createdByName?: string | null) {
    return createdByName || createdBy || 'Inconnu';
}

export const StateHistory = ({ label, records }: { label?: string; records: StateRecord[] }) => {
    const history = [...records].reverse();
    return (
        <div className="flex flex-col gap-[5px]">
            {label ? <TotemLabel>{label}</TotemLabel> : null}
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Statut</TableHead>
                        <TableHead>Date de création</TableHead>
                        <TableHead>Créateur.ice</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {history.map(({ state, createdAt, createdBy, createdByName }, index) => (
                        <TableRow key={index}>
                            <TableCell>{state}</TableCell>
                            <TableCell>{getExtendedFormattedDatetime(createdAt)}</TableCell>
                            <TableCell>{getCreatorName(createdBy, createdByName)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
